<template>
  <div class="pop-one">

    <div class="a-box beige">
      <div class="pure-g">
        <div class="pure-u-1-1 pure-u-md-1-3 fixed-text-box" v-html="$lang[('pop_intro_' + personId)]"></div>
        <div class="pure-u-1-2 pure-u-md-1-3 icon-holder">
          <div :class="['icon', (popPersons[personId].icon)]"></div>
        </div>
        <div class="pure-u-1-2 pure-u-md-1-3 icon-holder">
          <div class="icon pop-1-spin-1"></div>
        </div>
      </div>
    </div>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div
          :class="[
            'box-left',
            'pure-u-1-1',
            {'pure-u-md-1-2': (popPersons[personId].dialog_special === undefined)},
            {'pure-u-md-2-3': (popPersons[personId].dialog_special !== undefined)}
            ]"
        >
          <h2 v-if="(popPersons[personId].dialog_special === undefined)" v-html="$lang.talking"></h2>
          <h2 v-if="(popPersons[personId].dialog_special !== undefined)" v-html="$lang.talking_same"></h2>
          <p v-html="$lang[('pop_1_sec_txt_' + personId)]"></p>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2"></div>
      </div>
    </div>

    <div class="a-box turquoise content-holder">
      <div class="context left">
        <h3 v-html="$lang[('pop_dia_context_left_' + personId)]"></h3>
      </div>
      <div class="context right">
        <h3 v-html="$lang[('pop_dia_context_right_' + personId)]"></h3>
      </div>

      <div class="content-center pure-g">
        <div class="pure-u-1-1 bubble-box">
          <div class="bubbel-wrapper"
             v-for="(pers, i) in popPersons[personId].both_dialog"
             :key="i"
          >
            <div :class="['q-bubble', (pers.class)]">
              <p v-html="$lang[pers.key]"></p>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2">
          <h2 v-html="$lang.test"></h2>
          <p v-html="questionText"></p>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2"></div>
      </div>
    </div>

    <div ref="scollBy" class="test-holder">
      <div class="test-wrapper">

        <div class="test-part pure-g" v-if="currQuestion < 3">
          <div
            :class="[
              'test-left',
              'pure-u-1-1',
              'pure-u-md-1-2',
              {'last-text': lastText},
              {'dimmed': dimmedLeft}
             ]"
          >
            <p v-show="!lastText" class="nr-off">{{$lang.question}} {{(currQuestion + 1)}}/3</p>
            <div class="dimmed-box">
              <div class="dimmed-blocker"></div>

              <!-- First question -->
              <div v-show="currQuestion === 0">
                <h4>{{$lang[(popData.popups[personId].header)]}}</h4>
                <p class="exp" v-html="$lang[(popData.popups[personId].expression)]"></p>
                <p><i v-html="questionOne"></i></p>

                <div class="m-btn-wrapper">
                  <div v-for="(btn, i) in popData.shared.btns" :key="i"
                       :class="['multi-btns', {'selected': (firstStep === i)}]"
                       v-touch:tap="showSymptomFB(i)"
                  >
                    <p>{{ $lang[btn] }}</p>
                  </div>
                </div>

              </div>

              <!-- Second question -->
              <div v-show="currQuestion === 1">
                <h4>{{$lang.poss_reason}}</h4>
                <p class="exp" v-html="$lang.poss_reason_ingress"></p>
                <p><i v-html="questioTwo"></i></p>

                <div class="m-btn-wrapper">
                  <div v-for="(btn, y) in popData.shared.btns_fb" :key="y"
                       :class="['multi-btns', {'selected': (secondStep === y)}]"
                       v-touch:tap="showSymptomFB(y)"
                  >
                    <p>{{ $lang[btn] }}</p>
                  </div>
                </div>
              </div>

              <!-- Third question -->
              <div v-show="currQuestion === 2 && !lastText">
                <h4>{{$lang.poss_actions}}</h4>
                <p class="exp" v-html="$lang.poss_actons_ingress"></p>
                <p><i v-html="questionThree"></i></p>

                <div class="m-btn-wrapper">
                  <div v-for="(btn, x) in popData.shared.bnts_fb_2" :key="x"
                       :class="['multi-btns', {'selected': (thirdStep === x)}]"
                       v-touch:tap="showSymptomFB(x)"
                  >
                    <p>{{ $lang[btn] }}</p>
                  </div>
                </div>
              </div>

              <div v-show="lastText" v-html="$lang.last_text"></div><!-- v-html="$lang[(popData.popups[personId].last_text)]" -->

            </div>

          </div>

          <div class="test-right pure-u-1-1 pure-u-md-1-2">

            <!-- First answer -->
            <div v-show="currQuestion === 0" class="test-inner-wrapper">
              <div class="icon-wrapper">
                <div class="icon pop-1-spin-2"></div>
              </div>

              <div class="selection-wrapper">
                <div class="select-field">
                  <p class="nr-before">1</p>
                  <p></p>
                </div>
                <div class="select-field">
                  <p class="nr-before">2</p>
                  <p></p>
                </div>
                <div class="select-field">
                  <p class="nr-before">3</p>
                  <p></p>
                </div>
              </div>
            </div>

            <!-- First overlay -->
            <transition name="fadein-right">

              <div v-if="firstStep >= 0 && currQuestion === 0" class="fb-wrapper">

                <transition name="fade">
                  <div v-show="!secondScreening" class="screen-first">

                    <h4 v-html="$lang.screen_q" class="header"></h4>
                    <p v-html="$lang.pop_screen"></p>
                    <p><i v-html="personQuestion"></i></p>

                    <div class="btn-wrapper inline">
                      <div
                        :class="['btn', 'squere', {'selected': (btnYesNo === 1)}]"
                        v-touch:tap="checkIfCorrect(1, 1)"
                      >
                        <p>{{$lang.yes}}</p>
                      </div>
                      <div
                        :class="['btn', 'squere', {'selected': (btnYesNo === 2)}]"
                        v-touch:tap="checkIfCorrect(1, 2)"
                      >
                        <p>{{$lang.no}}</p>
                      </div>
                    </div>

                    <transition name="fade">
                      <div v-show="(btnYesNo > 0)" class="first-fb">
                        <p v-html="$lang.feedback"></p>
                        <p v-if="canMoveToSecond" v-html="yesByName"></p>
                        <p v-if="!canMoveToSecond" v-html="noByName"></p>
                      </div>
                    </transition>

                    <transition name="fade">
                      <div v-show="(btnYesNo > 0 && canMoveToSecond)" class="btn white arrow" v-touch:tap="screeningRes(1)">
                        <p>{{ $lang.continue }}</p>
                      </div>
                    </transition>

                  </div>
                </transition>

                <transition name="fade">
                  <div v-show="secondScreening" class="screen-second">
                    <h4 v-html="$lang.followup_q"></h4>

                    <div class="">
                      <p v-html="$lang.screening_yes"></p>
                      <ul v-html="followupByName"></ul>
                    </div>

                    <div v-show="(btnYesNo > 0 && canMoveToSecond)" class="btn white arrow" v-touch:tap="moveOn(1)">
                      <p>{{ $lang.continue }}</p>
                    </div>
                  </div>
                </transition>

              </div>

            </transition>

            <!-- Second answer -->
            <div v-show="currQuestion === 1">
              <div class="icon-wrapper">
                <div class="icon pop-1-spin-3"></div>
              </div>

              <div class="selection-wrapper second">

                <transition name="fade-out">
                  <div v-show="!secondStepFB" class="second-first">
                    <div class="select-field">
                      <p class="nr-before">1</p>
                      <p>{{ $lang[(popData.shared.btns[firstStep])] }}</p>
                    </div>

                    <div class="select-field">
                      <p class="nr-before">2</p>
                      <p v-if="secondStep > -1">{{ $lang[(popData.shared.btns_fb[secondStep])] }}</p>
                      <p v-else></p>
                    </div>

                    <div class="select-field">
                      <p class="nr-before">3</p>
                      <p></p>
                    </div>
                  </div>
                </transition>

                <transition name="fade-in">
                  <div v-show="secondStepFB" class="first-fb">
                    <p v-html="$lang.feedback"></p>
                    <p v-if="secondStep > -1" v-html="$lang[(popData.shared.txt_a_sec_1)]"></p>
                    <p v-else></p>
                  </div>
                </transition>

                <div v-show="(!secondStepFB && secondStep > -1)" class="btn-wrapper">
                  <div
                    class="btn white arrow"
                    v-touch:tap="showSecondFeedback"
                  >
                    <p>{{$lang.continue}}</p>
                  </div>
                </div>

                <div v-show="secondStepFB" class="btn-wrapper">
                  <div
                    class="btn white arrow"
                    v-touch:tap="moveToThird"
                  >
                    <p>{{$lang.continue}}</p>
                  </div>
                </div>
              </div>

            </div>

            <!-- Third answer -->
            <div v-show="currQuestion === 2">
              <div class="icon-wrapper">
                <transition name="fade">
                  <div v-show="!lastText" class="icon pop-1-spin-4"></div>
                </transition>
                <transition name="fade">
                  <div v-show="lastText" class="icon pop-1-spin-5"></div>
                </transition>
              </div>

              <div class="selection-wrapper second">

                <transition name="fade-out">
                  <div v-show="(!thirdStepFB) && !lastText" class="second-first">

                    <div class="select-field">
                      <p class="nr-before">1</p>
                      <p>{{ $lang[(popData.shared.btns[firstStep])] }}</p>
                    </div>

                    <div class="select-field">
                      <p class="nr-before">2</p>
                      <p>{{ $lang[(popData.shared.btns_fb[secondStep])] }}</p>
                    </div>

                    <div class="select-field">
                      <p class="nr-before">3</p>
                      <p v-if="thirdStep > -1">{{ $lang[(popData.shared.bnts_fb_2[thirdStep])] }}</p>
                      <p v-else></p>
                    </div>

                  </div>
                </transition>

                <transition name="fade-in">
                  <div v-show="thirdStepFB && !lastText" class="first-fb">
                    <p v-html="$lang.feedback"></p>
                    <p v-if="thirdStep > -1" v-html="$lang[(popData.shared.txt_a_sec_2)]"></p>
                    <p v-else></p>
                  </div>
                </transition>

                <div v-show="!thirdStepFB && thirdStep > -1 && !lastText" class="btn-wrapper">
                  <div
                    class="btn white arrow"
                    v-touch:tap="showThirdFeedback"
                  >
                    <p>{{$lang.continue}}</p>
                  </div>
                </div>

                <div v-show="thirdStepFB && !lastText" class="btn-wrapper">
                  <div
                    class="btn white arrow"
                    v-touch:tap="showFinish"
                  >
                    <p>{{$lang.on_done}}</p>
                  </div>
                </div>

                <transition name="fade-in-last">
                  <div v-show="lastText" class="second-first third">

                    <div class="select-field">
                      <p class="nr-before">1</p>
                      <p>{{ $lang[(popData.shared.btns[firstStep])] }}</p>
                    </div>

                    <div class="select-field">
                      <p class="nr-before">2</p>
                      <p>{{ $lang[(popData.shared.btns_fb[secondStep])] }}</p>
                    </div>

                    <div class="select-field">
                      <p class="nr-before">3</p>
                      <p v-if="thirdStep > -1">{{ $lang[(popData.shared.bnts_fb_2[thirdStep])] }}</p>
                      <p v-else></p>
                    </div>

                  </div>
                </transition>

              </div>
            </div>

            <div v-show="lastText" class="multi-btn">
              <div class="btn-wrapper">
                <div class="btn white" v-touch:tap="closePopup">
                  <p>{{$lang.to_part}} 2</p>
                </div>
              </div>
              <div v-if="personId < 11" class="btn-wrapper">
                <div class="btn white arrow" v-touch:tap="toNextCase">
                  <p>{{$lang.to_next}}</p>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'pop-one',
  data () {
    return {
      currQuestion: 0,
      secondScreening: false,
      secondSecondScreening: false,
      thirdSecondScreening: false,
      canMoveToSecond: false,
      canMoveToThird: false,
      secondStepFB: false,
      thirdStepFB: false,
      firstStep: -1,
      secondStep: -1,
      thirdStep: -1,
      btnYesNo: 0,
      lastText: false,
      dimmedLeft: false
    }
  },
  props: {
    popData: {
      type: Object,
      required: true
    },
    popPersons: {
      type: Array,
      required: true
    },
    personId: {
      type: Number,
      required: true
    },
    scrollBase: {
      type: String,
      default: ''
    }
  },
  computed: {
    yesByName () {
      return this.util.replacePlaceholderWithString(this.$lang[this.popData.shared.txt_a_yes], [this.popPersons[this.personId].name])
    },
    noByName () {
      return this.util.replacePlaceholderWithString(this.$lang[this.popData.shared.txt_a_no], [this.popPersons[this.personId].name])
    },
    personQuestion () {
      return this.util.replacePlaceholderWithString(
        this.$lang[this.popData.shared.txt_q[this.firstStep]],
        [
          this.popPersons[this.personId].name,
          this.$lang[(this.popPersons[this.personId].sex + '_single')],
          this.$lang[(this.popPersons[this.personId].sex + '_multi')],
          this.$lang[(this.popPersons[this.personId].sex + '_possesive')]
        ]
      )
    },
    questionText () {
      return this.util.replacePlaceholderWithString(this.$lang.pop_1_sec_2_txt, [this.popPersons[this.personId].name])
    },
    questionOne () {
      return this.util.replacePlaceholderWithString(this.$lang.pop_q_1_1_state, [this.popPersons[this.personId].name])
    },
    questioTwo () {
      return this.util.replacePlaceholderWithString(this.$lang.pop_q_1_2_state, [this.popPersons[this.personId].name])
    },
    questionThree () {
      return this.util.replacePlaceholderWithString(this.$lang.pop_q_1_3_state, [this.popPersons[this.personId].name])
    },
    followupByName () {
      return this.util.replacePlaceholderWithString(
        this.$lang[(this.popData.popups[this.personId].sumptom)],
        [
          this.popPersons[this.personId].name,
          this.$lang[(this.popPersons[this.personId].sex + '_single')],
          this.$lang[(this.popPersons[this.personId].sex + '_multi')],
          this.$lang[(this.popPersons[this.personId].sex + '_possesive')]
        ]
      )
    }
  },
  methods: {
    closePopup () {
      let self = this
      return self.onClosePopup()
    },
    onClosePopup () {
      this.$bus.$emit('CLOSE.FACT')
    },
    toNextCase () {
      let self = this
      return self.onToNextCase()
    },
    onToNextCase () {
      this.$bus.$emit('NEXT.FACT', {modal: (this.personId + 1)})
    },
    showFinish () {
      let self = this
      return self.onShowFinish()
    },
    onShowFinish () {
      this.dimmedLeft = false
      this.lastText = true
      this.scrollToOverlayTop()
    },
    moveToThird () {
      let self = this
      return self.onMoveToThird()
    },
    onMoveToThird () {
      this.dimmedLeft = false
      this.currQuestion = 2
      this.scrollToOverlayTop()
    },
    showSecondFeedback () {
      let self = this
      return self.onShowSecondFeedback()
    },
    onShowSecondFeedback () {
      this.secondStepFB = true
      this.scrollToOverlayTop()
    },
    showThirdFeedback () {
      let self = this
      return self.onShowThirdFeedback()
    },
    onShowThirdFeedback () {
      this.thirdStepFB = true
      this.scrollToOverlayTop()
    },
    showSymptomFB (index) {
      let self = this
      return () => {
        self.onShowSymptomFB(index)
      }
    },
    onShowSymptomFB (index) {
      if (this.dimmedLeft) {
        return false
      }

      if (this.currQuestion === 0) {
        if (this.firstStep === index) {
          this.firstStep = -1
          this.btnYesNo = 0
          this.canMoveToSecond = false
          this.secondScreening = false
        } else {
          if (this.popPersons[this.personId].q_one !== index) {
            this.canMoveToSecond = false
          }
          this.firstStep = index
          this.btnYesNo = 0
        }
      }

      if (this.currQuestion === 1) {
        this.dimmedLeft = true

        if (this.secondStep === index) {
          this.secondStep = -1
          this.canMoveToThird = false
        } else {
          this.secondStep = index
        }
      }

      if (this.currQuestion === 2) {
        this.dimmedLeft = true

        if (this.thirdStep === index) {
          this.thirdStep = -1
        } else {
          this.thirdStep = index
        }
      }

      // this.scrollToOverlayTop()
    },
    screeningRes (question) {
      let self = this
      return () => {
        self.onScreeningRes(question)
      }
    },
    onScreeningRes (question) {
      if (question === 1) {
        this.secondScreening = true
      }

      if (question === 2) {
        this.secondSecondScreening = true
      }

      this.scrollToOverlayTop()
    },
    scrollToOverlayTop () {
      if (this.scrollBase !== '') {
        this.$nextTick(() => {
          this.$scrollTo(this.$refs.scollBy, '500', {container: ('#' + this.scrollBase)})
        })
      }
    },
    checkIfCorrect (question, answer) {
      let self = this
      return () => {
        self.onCheckIfCorrect(question, answer)
      }
    },
    onCheckIfCorrect (question, answer) {
      if (question === 1) {
        if (this.firstStep === this.popPersons[this.personId].q_one) {
          this.canMoveToSecond = true
          this.dimmedLeft = true
        }
        this.btnYesNo = answer
      }

      /**
      if (question === 2) {
        if (this.firstStep === this.popPersons[this.personId].q_one) {
          this.canMoveToSecond = true
        }
        this.btnYesNo = answer
      }
      **/
    },
    moveOn (nr) {
      let self = this
      return () => {
        self.onMoveOn(nr)
      }
    },
    onMoveOn (nr) {
      this.dimmedLeft = false

      if (nr === 1 && this.firstStep > -1) {
        this.scrollToOverlayTop()
        this.currQuestion = nr
      }

      if (nr === 2 && this.secondStep > -1) {
        this.currQuestion = nr
      }

      if (nr === 3 && (this.thirdStep <= -1)) {
        this.currQuestion = nr
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/popups/pop-one/index.vue